import { useEffect, useState } from 'react';
import { useLogin } from '../../../../context/Login/LoginContext';
import { Workspace } from '../../types/types';
import useStorage_Local from './Storage/LocalStorage/useStorage_Local';
import useStorage_Server from './Storage/Server/useStorage_Server';
import useCurrentWorkspace from './Storage/useCurrentWorkspace';
import { TodoContextType } from './TodoContext';

export const useTodoManager = (): TodoContextType => {
    const currentWorkspaceManager = useCurrentWorkspace();
    const { currentWorkspaceId, setCurrentWorkspaceId } = currentWorkspaceManager;
    const { refresh: refreshServer, clear: clearServer, ...storageServer } = useStorage_Server(currentWorkspaceManager);
    const { refresh: refreshLocal, ...storageLocal } = useStorage_Local(currentWorkspaceManager);

    const { workspaceMap: workspaceMapServer, refreshTodo: refreshTodoServer, refreshTodoList: refreshTodoListServer, refreshWorkspace: refreshWorkspaceServer } = storageServer;
    const { refreshTodo: refreshTodoLocal, refreshTodoList: refreshTodoListLocal, refreshWorkspace: refreshWorkspaceLocal } = storageLocal;

    const { isLoggedIn } = useLogin();
    const [useServer, setUseServer] = useState(false);

    useEffect(() => {
        refreshLocal();
        if (!isLoggedIn) {
            clearServer();
            setUseServer(false);
            return;
        }
        refreshServer();
    }, [clearServer, isLoggedIn, refreshServer, refreshLocal]);

    useEffect(() => {
        const shouldUseServer = !!workspaceMapServer.get(currentWorkspaceId ?? "");
        setUseServer(shouldUseServer);
        if (shouldUseServer) {
            refreshTodoServer();
            refreshTodoListServer();
        } else {
            refreshTodoLocal();
            refreshTodoListLocal();
        }
    }, [currentWorkspaceId, refreshTodoListLocal, refreshTodoListServer, refreshTodoLocal, refreshTodoServer, workspaceMapServer]);

    const storage = useServer ? storageServer : storageLocal;

    const addWorkspace = async (isLocal: boolean) => {
        if (isLocal)
            return storageLocal.createWorkspace();
        else
            return storageServer.createWorkspace();
    }

    const updateWorkspace = async (workspaceId: string, updates: Partial<Workspace>) => {
        if (workspaceMapServer.get(workspaceId))
            return storageServer.updateWorkspace(workspaceId, updates);
        else
            return storageLocal.updateWorkspace(workspaceId, updates);
    }

    const deleteWorkspace = async (workspaceId: string) => {
        if (workspaceMapServer.get(workspaceId))
            return storageServer.deleteWorkspace(workspaceId);
        else
            return storageLocal.deleteWorkspace(workspaceId);
    }

    return {
        //Todo
        todos: storage.todos,
        todosMap: storage.todosMap,
        addTodo: storage.createTodo,
        editTodo: storage.updateTodo,
        deleteTodo: storage.deleteTodo,
        toggleTodo: storage.toggleTodo,
        addTodoByTodoData: storage.createTodoByTodoData,
        moveTodoToList: storage.moveTodoToList,

        //Workspace
        workspacesServer: storageServer.workspaces,
        workspacesLocal: storageLocal.workspaces,
        addWorkspace: addWorkspace,
        updateWorkspace: updateWorkspace,
        deleteWorkspace: deleteWorkspace,
        activeWorkspace: currentWorkspaceId,
        currentWorkspace: storage.workspaceMap.get(currentWorkspaceId ?? ""),
        setActiveWorkspace: setCurrentWorkspaceId,

        //List
        lists: storage.todoLists,
        workspacesList: storage.todoLists,
        addList: storage.createTodoList,
        updateListTitle: storage.updateListTitle,
        deleteList: storage.deleteTodoList,
        reorderList: storage.reorderList,
    }
};